import React from "react";

export default function ArrowAngleUpIcon() {
    return (
        <svg
            width="10"
            height="8"
            viewBox="0 0 10 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g transform="rotate(180, 5, 4)">
                <path
                    d="M4.46875 7.00938L0.21875 2.75938C-0.0750001 2.46563 -0.0750001 1.99062 0.21875 1.7L0.925 0.99375C1.21875 0.7 1.69375 0.7 1.98437 0.99375L4.99687 4.00625L8.00937 0.99375C8.30312 0.7 8.77813 0.7 9.06875 0.99375L9.775 1.7C10.0687 1.99375 10.0687 2.46875 9.775 2.75938L5.525 7.00938C5.2375 7.30313 4.7625 7.30313 4.46875 7.00938Z"
                    fill="#333333"
                />
            </g>
        </svg>
    );
}
